export enum AppLocalizationStrings {
  $id = 'app.localization',
  about = 'About',
  aboutDesc = 'About the application',
  home = 'REST Help page',
  homeDesc = 'Services, business activity queries, Epicor functions',

  menuBOServices = 'Services: BO Namespace',
  menuLibServices = 'Services: Lib Namespace',
  menuProcServices = 'Services: Proc Namespace',
  menuRptServices = 'Services: Rpt Namespace',
  menuUDServices = 'Services: UD Namespace',

  menuBAQ = 'Business Activity Queries',
  menuFunctions = 'Epicor Functions',
  apiKeyPlaceHolder = 'Set in the Header above',
  useSearchBAQ = 'Use search on the left to find BAQ',
  selectItemFromTheList = 'Select one of the items from the list on the left.',
  lblAddHeader = 'Add header',
  SelectHeaderLbl = 'Select header',
  authHeaderDescr = 'Set this header only to override default application behaviour',

  radSkipAuthHeader = 'Do not send header',
  radBasicAuth = 'Use Basic Authentication',
  radHeaderValue = 'Set header value',

  authHeaderUsername = 'User Name',
  authHeaderPassword = 'Password',
  authHeaderValueLabel = `Full header value, like 'Bearer ...' `,

  editFavoriteItem = 'Edit Favorite Item',
  selectFolder = 'Select Folder',
  itemName = 'Name',
  folder = 'Folder',
  newFolder = 'Type New Folder...',
  rootFolder = 'Root Folder',
  editDialogTitle = 'EDIT FAVORITE MENU',
  saveBtn = 'SAVE',
  removeBtn = 'REMOVE',
  deleteBtn = 'DELETE',
  doneBtn = 'DONE',
  folderDialogTitle = 'EDIT FAVORITE FOLDER',
  folderName = 'Folder Name',
  deleteFolder = 'Are you sure you want to delete this folder?',
  favoriteMenusRemoved = 'If yes, all the favorite menus inside the folder will be removed and this action is undoable',
  defaultFavFolder = 'Favorites',
  errorTitle = 'Error',
}
